import { motion } from "framer-motion";

const FENCE_IMG =
  "https://images.unsplash.com/photo-1768815022389-720cc089f40e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

const steps = [
  { n: "01", title: "Sign Up", desc: "Pick your role — player, manager, sponsor, umpire or volunteer — and tell us your background." },
  { n: "02", title: "Get Placed", desc: "We organize teams and rosters by experience to keep games balanced and competitive." },
  { n: "03", title: "Play Ball", desc: "Show up on weekends, compete, and enjoy the game you love with people who get it." },
];

export const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 lg:py-32 grain overflow-hidden"
    >
      <div className="absolute inset-0 bg-cover bg-center bg-fixed" style={{ backgroundImage: `url(${FENCE_IMG})` }} />
      <div className="absolute inset-0 bg-[#0A0A0A]/90" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="text-[#F4A261] text-xs font-bold uppercase tracking-[0.3em]">How It Works</span>
          <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
            From The Bench To The Box In Three Steps
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`how-step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="border-t-2 border-[#FF3B30] pt-6"
            >
              <p className="font-heading text-6xl text-white/15 leading-none">{s.n}</p>
              <h3 className="text-2xl uppercase tracking-tight mt-4 mb-3">{s.title}</h3>
              <p className="text-[#C7CDD4] font-medium leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
